import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { OrganizationAdminModel } from './organizationAdmin.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class OrganizationAdminService {
    constructor(private authService: AuthService, private http: Http) { }

    public GetOrganizationAdminList(organizationMasterHashID: string, input?: DataListModel): Observable<IAPIResponse> {
        let getOrganizationAdminUrl = WeGoConfig.API_GET_ORGANIZATION_ADMIN_LIST;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getOrganizationAdminUrl = getOrganizationAdminUrl + "?" + queryString + "&organizationHashID=" + organizationMasterHashID;
        }
        else {
            getOrganizationAdminUrl = getOrganizationAdminUrl + "?organizationHashID=" + organizationMasterHashID;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getOrganizationAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public ExportOrganizationAdminList(organizationMasterHashID: string, input?: DataListModel): any {
        input.currentPage = 0;
        let queryString = this.authService.HandleAPIListInput(input);
        let getOrganizationAdminUrl = WeGoConfig.API_EXPORT_ORGANIZATIONY_ADMIN_LIST + "?" + queryString + "&organizationHashID=" + organizationMasterHashID;
        let headers = this.authService.GetHeader('text/csv');
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getOrganizationAdminUrl, options);
    }
   public GetPersonListByOrganizationId(organizationMasterHashId: string, input?: DataListModel): Observable<IAPIResponse> {
        let getPersonUrl = WeGoConfig.API_GET_PERSON_LIST_BY_ORGANIZATION_ID;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getPersonUrl = getPersonUrl + "?" + queryString + "&organizationMasterHashId=" + organizationMasterHashId;
        }
        else {
            getPersonUrl = getPersonUrl + "?organizationMasterHashId=" + organizationMasterHashId;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getPersonUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
    public AddNewOrganizationAdmin(organizationAdminModel: OrganizationAdminModel): Observable<IAPIResponse> {
        let body = organizationAdminModel;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });

        return this.http.post(WeGoConfig.API_POST_ORGANIZATION_ADMIN_DETAIL, body, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public DeleteOrganizationAdmin(selectedOrganizationAdminList: string[]): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });

        return this.http.post(WeGoConfig.API_POST_DELETE_ORGANIZATION_ADMIN, selectedOrganizationAdminList, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
     public InActiveOrganizationAdmin(organizationAdminHashId: string) {
        let getInactiveOrganizationAdminUrl = WeGoConfig.API_GET_INACTIVE_ORGANIZATION_ADMIN + "?organizationAdminHashId=" + organizationAdminHashId;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getInactiveOrganizationAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationadmin/models/organizationAdmin.service.ts